import Vue from 'vue'
import Vuex from 'vuex'
import Card from './modules/Card'
import Cart from './modules/Cart'
import Customer from './modules/Customer'
import Checkout from './modules/Checkout'
import Countries from './modules/Countries'
import Settings from './modules/Settings'
import ApplePay from './modules/ApplePay'

Vue.use(Vuex)

export default new Vuex.Store({
  state: () => ({
    pl: '',
    globalLoading: true,
    containerLoading: false,
    isEnabledNextStep: false,
  }),
  getters: {
    getPl: (state) => state.pl,
    getGlobalLoading: (state) => state.globalLoading,
    getContainerLoading: (state) => state.containerLoading,
    getIsEnabledNextStep: (state) => state.isEnabledNextStep,
  },
  mutations: {
    SET_PL: (state, pl) => {
      state.pl = pl
    },
    SET_GLOBAL_LOADING: (state, status = true) => {
      state.globalLoading = status
    },
    SET_CONTAINER_LOADING: (state, status = false) => {
      state.containerLoading = status
    },
    SET_IS_ENABLED_NEXT_STEP: (state, status = false) => {
      state.isEnabledNextStep = status
    },
  },
  modules: {
    Card,
    Cart,
    Customer,
    Checkout,
    Settings,
    Countries,
    ApplePay,
  },
})
